/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Form, FormGroup, Label, Row, Col, Input, Button } from 'reactstrap'

import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';
import InputNumber from 'rc-input-number';
import IPut from 'iput';

import PasswordWidget from '../widgets/PasswordWidget.js'

import {CopyToClipboard} from 'react-copy-to-clipboard';

import {AppContext} from '../AppContext';

class GenerateSecureWeblink extends React.Component
{
  yesterday = Datetime.moment().subtract( 1, 'day' );
  ipAddress = "";
  ipAddressHelp = 'If checked, the IP address of the computer that uses the generated filename must match the specified IP address.';

  constructor(props)
  {
    super();

    this.firstColumnSize = ('modal-lg' === props.modalSize ? '3' : '3');    
    
    let contentDisposition = (null !== props.selectedObject.htmlElement ? 'STREAM' : 'DOWNLOAD');
    
    this.state =
    {
      generatedWeblink: '',
      name: props.selectedObject.objectName,
      source: props.selectedObject.sourcePath,
      objectType: props.selectedObject.objectType,
      expirationDate: '',
      customDateDisabled: true,
      numericInputDisabled: true,
      copyDisabled: true,
      generateDisabled: false,
      password: '',
      passwordRequired: false,
      passwordValid: undefined,
      passwordFB: null,
      passwordDisabled: true,
      passwordScore: null,
      passwordFocused: false,
      passwordHint: "The Password Required checkbox has to be checked...",
      accessMode: 'R',
      sessionIdCheck: false,
      expireIn: '1 Minute',
      restrictToIp: false,
      contentDisposition: contentDisposition,
      accessLimit: 1,
      note: ''
    }

    this.setNote = this.setNote.bind(this);
    this.customAccessLimitChanged = this.customAccessLimitChanged.bind(this);    
    this.validDate = this.validDate.bind(this);
    this.expirationDateChanged = this.expirationDateChanged.bind(this);
    this.setExpirationDate = this.setExpirationDate.bind(this);
    this.toggleRestrictToIp = this.toggleRestrictToIp.bind(this);
    this.togglePasswordRequired = this.togglePasswordRequired.bind(this);
    this.contentDispositionChanged = this.contentDispositionChanged.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.generateWeblinkPassword = this.generateWeblinkPassword.bind(this);
    this.ipAddressChanged = this.ipAddressChanged.bind(this);
  }

  contentDispositionChanged(contentDisposition)
  {
    if ('DOWNLOAD' === contentDisposition)
      this.setState({contentDisposition: 'DOWNLOAD'});
    else
      this.setState({contentDisposition: 'STREAM'});
  }

  customAccessLimitChanged(valueAsNumber, valueAsString, input)
  {
    this.setState({accessLimit: valueAsNumber});
  }
  
  expirationDateChanged(expireIn, event)
  {
    let disabled = true;
    let customDisabled = true;

    if ('Specified' === expireIn)
    {
      customDisabled = false;
      if ('' !== this.state.expirationDate) disabled = false;
    }
    else
     disabled = false;

    this.setState(
    {
      customDateDisabled: customDisabled, 
      generateDisabled: disabled,
      expireIn: expireIn
    });
  }

  async generateWeblinkPassword()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateWeblinkPassword');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating weblink password');
    this.setPassword(result.jsonData.weblinkPassword);
  }

  async generateWeblink()
  {
    if (!this.ipAddressIsValid() && this.state.restrictToIp)
    {
      this.context.postNotification('error', 'Specify a valid IP Address');
      return;
    }

    this.setState({generateDisabled: true});

    let bodyData = {};
    bodyData.objectId = this.props.selectedObject.objectId;
    bodyData.validUntil = ('Specified' === this.state.expireIn ? this.state.expirationDate.unix() : this.state.expireIn);
    bodyData.accessLimit = this.state.accessLimit;
    bodyData.restrictToIpAddress = this.ipAddress;
    bodyData.contentDisposition = this.state.contentDisposition;
    bodyData.note = this.state.note;
    if (this.state.passwordRequired) bodyData.weblinkPassword = this.state.password;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateSecureWeblink', bodyData);
    if ('success' !== result.status)
    {
      this.setState({generateDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error generating weblink');
    } 
    this.setState({ generatedWeblink:  result.jsonData.secureWeblink });
    this.context.postNotification('info', "Weblink generated.  Click on the weblink to copy it to the paste buffer.");
    this.setState({generateDisabled: false, copyDisabled: false});
  }

  ipAddressChanged(value)
  {
    this.ipAddress = value;
  }

  ipAddressIsValid()
  {
    if (null === this.ipAddress) return false;

    if (this.ipAddress.match(window.ipAddressRegEx))
      return true;
    else
      return false;
  }

  render()
  {
    return(
      <div>
        <Row style={{paddingTop: "10px"}}>
          <Col  sm="2">Name</Col>
          <Col >{this.state.name}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col  sm="2">Object Type</Col>
          <Col >
            {this.state.objectType}
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col  sm="2">Source</Col>
          <Col >
            {this.state.source}
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Label sm="2">Access Limit</Label>
          <Col>
            <Form  >          
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input defaultChecked="checked" type="radio" name="accessLimitRadios" value={1} onClick={this.setAccessLimit.bind(this, 1)}/>
                  One Time
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="accessLimitRadios" value={-1} onClick={this.setAccessLimit.bind(this, -1)}/>
                  Unlimited
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="accessLimitRadios" value={undefined} onClick={this.setAccessLimit.bind(this, undefined)}/>
                  Specified
                </Label>
              </FormGroup>
              <FormGroup className="form-check-inline">
                <InputNumber id='accessLimit' min={1} max={99999} value={this.state.accessLimit} disabled={this.state.numericInputDisabled} 
                  onChange={this.customAccessLimitChanged} style={{ width: 100 }} />
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Expiration Date</Col>
          <Col>
            <Form >
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('1 Minute' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, '1 Minute')} 
                  />
                  1 Minute
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('1 Hour' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, '1 Hour')} 
                  />
                  1 Hour
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('1 Day' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, '1 Day')} 
                  />
                  1 Day
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('No Expiration' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, 'No Expiration')} 
                  />
                  No Expiration
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('Specified' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, 'Specified')}
                  />
                  Specified
                </Label>  
              </FormGroup>
              <FormGroup className="form-check-inline">
                <Datetime onChange={this.setExpirationDate} value={this.state.expirationDate} 
                  inputProps={{disabled: this.state.customDateDisabled, placeholder: "Select a specific date..."}} isValidDate={this.validDate} />
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Label check for="restrictToIp" sm="2" >Restrict to IP Address</Label>
          <Col >
            <Form >
              <FormGroup check className="form-check-inline" style={{paddingTop: '5px'}}>
                <Input type="checkbox" id="restrictToIp"  onChange={this.toggleRestrictToIp} checked={this.state.restrictToIp ? "checked" : ''} 
                  style={{ marginRight: '5px'}} title={this.ipAddressHelp}/>
              { this.state.restrictToIp &&
                <IPut  onChange={this.ipAddressChanged}/>
              }                  
              </FormGroup>
            </Form>
          </Col>
        </Row>
        { (null !== this.props.selectedObject.htmlElement) &&
          <Row style={{paddingTop: "10px"}}>
            <Col sm="2">Delivery Method</Col>
            <Col>
              <Form >
                <FormGroup check className="form-check-inline">
                  <Label check>
                    <Input type="radio" name="contentDisposition" checked={('STREAM' === this.state.contentDisposition ? 'checked' : '')} 
                      onChange={() => this.contentDispositionChanged('STREAM')} />
                    Streaming
                  </Label>
                </FormGroup>
                <FormGroup check className="form-check-inline">
                  <Label check>
                    <Input type="radio" name="contentDisposition" checked={('DOWNLOAD' === this.state.contentDisposition ? 'checked' : '')} 
                      onChange={() => this.contentDispositionChanged('DOWNLOAD')}  />
                    Download
                  </Label>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        }
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2"><Label for='passwordRequired' style={{paddingTop: '5px'}}>Password Required</Label></Col>
          <Col sm='1'>
            <Input style={{marginLeft: 0}} id="passwordRequired" onChange={this.togglePasswordRequired} 
              checked={this.state.passwordRequired ? "checked" : ''} type="checkbox" />
          </Col>
          <Col sm='4'>
            <PasswordWidget disabled={this.state.passwordDisabled} onChange={this.setPassword} value={this.state.password}
              passwordValid={this.state.passwordValid} focus={this.state.passwordFocused} zxcvbn={this.state.passwordScore}
              passwordFB={this.state.passwordFB} placeholder='Enter a password' id='password'
              passwordType='text' title={this.state.passwordHint}
            />
          </Col>
          <Col sm='3'>
            <Button disabled={this.state.passwordDisabled} onClick={this.generateWeblinkPassword} color='primary' title={this.state.passwordHint}>Generate</Button>
            &nbsp;
            <CopyToClipboard onCopy={() => this.context.postNotification('info', 'Weblink password copied to paste buffer.')} 
              text={this.state.password} 
            >
              <Button title={this.state.passwordHint} disabled={this.state.passwordDisabled} color='primary'>Copy</Button>
            </CopyToClipboard>          
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm='2'><Label for='notes'>Notes</Label></Col>
          <Col sm='4'>
            <Input type="textarea" id="note" value={this.state.note} onChange={this.setNote} placeholder={'Enter a note to associate with this secure weblink...'} />
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">
            <Button disabled={this.state.generateDisabled} onClick={() => this.generateWeblink()} color="primary">Get Weblink</Button>
          </Col>
          <Col >
            <CopyToClipboard text={this.state.generatedWeblink} onCopy={() => this.weblinkCopied()} >
              <span title='Click to Copy'>{this.state.generatedWeblink}</span>
            </CopyToClipboard>          
          </Col>
        </Row>
      </div>
    );
  }

  setAccessLimit(limit)
  {
    if (typeof(limit) === 'undefined')
      this.setState({numericInputDisabled: false});
    else
      this.setState({accessLimit: limit, numericInputDisabled: true});
  }

  setExpirationDate(date)
  {
    let disabled = ('object' === typeof date ? false : true);
    this.setState({expirationDate: date, generateDisabled: disabled});
  }

  setButtonState()
  {
    let disabled = false;

    if ('Specified' === this.state.expireIn && '' === this.state.expirationDate) disabled = true;

    this.setState({generateDisabled: disabled});
  }

  setNote(event)
  {
    this.setState({note: event.target.value});
  }

  setPassword(value)
  {
    let passwordValid = this.state.passwordValid;
    let password = this.state.password;
    let passwordScore = this.state.passwordScore;
    let passwordFB = null;

    password = value;
    passwordScore = window.getPasswordScore(password);
    if ('' === password)
    {
      passwordValid = false;
      passwordFB = 'You must enter a valid and strong password to continue.';
      passwordScore = null;
    }
    else if (passwordScore.score < this.context.websiteProfile.passwordStrength)
    {
      passwordFB = 'You must enter a stronger password.  The meter has to go green.';
      passwordValid = false;
    }
    else
    {
      passwordValid = true;
    }

    this.setState(
    {
      password: password,
      passwordValid: passwordValid,
      passwordFB: passwordFB,
      passwordScore: passwordScore
    });
  }

  togglePasswordRequired()
  {
    if (!this.state.passwordRequired) window.loadZxcvbn();

    this.setState(
    {
      passwordRequired: !this.state.passwordRequired,
      passwordDisabled: !this.state.passwordDisabled,
      passwordHint: !this.state.passwordDisabled ? "The Password Required checkbox has to be checked..." : null
    }, this.setButtonState);
  }

  toggleRestrictToIp()
  {
    this.setState({restrictToIp: !this.state.restrictToIp}, this.setButtonState);
    this.ipAddress = null;
  }

  validDate(current)
  {
    return current.isAfter(this.yesterday);
  } 

  weblinkCopied()
  {
    this.context.postNotification('info', 'Weblink copied to paste buffer.');
  }
}

GenerateSecureWeblink.contextType = AppContext;

export default GenerateSecureWeblink